/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { FocusTrapFactory } from "@angular/cdk/a11y";
import { OverlayRef } from "@angular/cdk/overlay";
import { CdkPortalOutlet } from "@angular/cdk/portal";
import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, NgZone, Optional, Output, Renderer2, ViewChild } from "@angular/core";
import { ANIMATION_MODULE_TYPE } from "@angular/platform-browser/animations";

import { NzConfigService } from "ng-zorro-antd/core/config";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzI18nService, NzModalI18nInterface } from "ng-zorro-antd/i18n";

import { UiModalOptions } from "../../modal.models";
import { nzModalAnimations, NzModalConfirmContainerComponent } from "ng-zorro-antd/modal";
import { TransformModalOptions } from "@webapp/ui/modal/utils/modal.utils";

@Component({
  selector: "ui-modal-confirm-container",
  exportAs: "uiModalConfirmContainer",
  templateUrl: "modal-confirm-container.component.html",
  animations: [nzModalAnimations.modalContainer],
  // Using OnPush for modal caused footer can not to detect changes. we can fix it when 8.x.
  changeDetection: ChangeDetectionStrategy.Default,
  host: {
    tabindex: "-1",
    role: "dialog",
    "[class]": 'config.nzWrapClassName ? "ant-modal-wrap " + config.nzWrapClassName : "ant-modal-wrap"',
    "[class.ant-modal-wrap-rtl]": `dir === 'rtl'`,
    "[class.ant-modal-centered]": "config.nzCentered",
    "[style.zIndex]": "config.nzZIndex",
    "[@.disabled]": "config.nzNoAnimation",
    "[@modalContainer]": "state",
    "(@modalContainer.start)": "onAnimationStart($event)",
    "(@modalContainer.done)": "onAnimationDone($event)",
    "(click)": "onContainerClick($event)",
    "(mouseup)": "onMouseup()",
  },
})
export class UiModalConfirmContainerComponent extends NzModalConfirmContainerComponent {
  @ViewChild(CdkPortalOutlet, { static: true }) portalOutlet!: CdkPortalOutlet;
  @ViewChild("modalElement", { static: true }) modalElementRef!: ElementRef<HTMLDivElement>;
  @Output() readonly cancelTriggered = new EventEmitter<void>();
  @Output() readonly okTriggered = new EventEmitter<void>();
  locale!: NzModalI18nInterface;

  constructor(
    ngZone: NgZone,
    i18n: NzI18nService,
    elementRef: ElementRef,
    focusTrapFactory: FocusTrapFactory,
    cdr: ChangeDetectorRef,
    render: Renderer2,
    overlayRef: OverlayRef,
    nzConfigService: NzConfigService,
    public modalConfig: UiModalOptions,
    @Optional() @Inject(DOCUMENT) document: NzSafeAny,
    @Optional() @Inject(ANIMATION_MODULE_TYPE) animationType: string
  ) {
    super(ngZone, i18n, elementRef, focusTrapFactory, cdr, render, overlayRef, nzConfigService, TransformModalOptions(modalConfig), document, animationType);
  }
}
